import { IPersonalDetails } from 'API';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';
import { FormSection, AddressTab } from 'Components';
import { useDictionary } from 'Hooks';
export const ThirdSection = () => {
  const baseName = 'residentialAddressSection.israeliAddressRelation';
  const {
    formState: { errors },
  } = useFormContext<IPersonalDetails>();

  const dictionary = useDictionary(Dictionary, DICTIONARY.PERSONAL_DETAILS);

  const { residentialAddressSection } = errors;
  const israeliAddressRelationErrors =
    residentialAddressSection?.israeliAddressRelation;
  const address = {
    houseNumErrorMsg: israeliAddressRelationErrors?.apartmentNumber?.message,
    streetNameErrorMsg: israeliAddressRelationErrors?.street?.message,
    streetNumErrorMsg: israeliAddressRelationErrors?.homeNumHouse?.message,
    zipCodeErrorMsg: israeliAddressRelationErrors?.israeliZipCode?.message,
    cityName: `${baseName}.israeliTownId`,
    houseNum: `${baseName}.apartmentNumber`,
    streetName: `${baseName}.street`,
    streetNumName: `${baseName}.homeNumHouse`,
    zipCodeName: `${baseName}.israeliZipCode`,
  };

  return (
    <FormSection disableGutter grouped id={dictionary.thirdSectionTitle}>
      <Typography fontWeight={700} id={dictionary.thirdSectionTitle}>
        {dictionary.thirdSectionTitle}
      </Typography>
      <AddressTab {...address} />
    </FormSection>
  );
};
